module Meevo.Plugins.Register {
    "use strict";

    export class PackageRedemptionSection extends Meevo.Plugins.Register.RegisterSectionBase {

        protected selectedSaleLine: Model.SaleLine;
        public packageRedemptionPath: Model.PackageRedemptionPath = null;
        public packageServicesRemaining: any[];
        public packageRedemptionTypeNames: any[];
        private cleanupTask: ng.IPromise<any>;

        get $q() { return this.registerContext.$q; }

        get dataService() { return this.registerContext.dataService; }
        get modalService() { return this.registerContext.modalService; }
        get busyService() { return this.registerContext.busyService; }

        constructor(registerContext: Meevo.Plugins.Register.RegisterContext) {
            super(RegisterSectionTypeEnum.PackageRedemption, registerContext, "packageRedemption", Register.RegisterSectionCatTypeEnum.Sale);

            this.dataService.getEnumList(Meevo.Model.EnumTypeEnum.PackageRedemptionTypeEnum)
                .then((data: any) => {
                    this.packageRedemptionTypeNames = data;
                });
        }

        reset() {
            this.selectedSaleLine = null;
            this.cleanupTask = this.cleanupClientPackageRedemptionPath();
        }

        initialize(sale: Model.Sale, selectedSaleLine: Model.SaleLine) {
            this.selectedSaleLine = selectedSaleLine;

            let newPackageIds = [];
            let usedPackageServiceIds = [];

            for (const saleLine of this.registerContext.sale.saleLines) {
                switch (saleLine.saleType) {
                    case Model.SalesTypeEnum.Package:
                        newPackageIds.push(saleLine.item.id);
                        break;

                    case Model.SalesTypeEnum.PackageMerge:
                    case Model.SalesTypeEnum.PackageSplit:
                        let clientPackage = (saleLine.item as PackageSaleLineItem).clientPackage;
                        if (!clientPackage) {
                            continue;
                        }

                        newPackageIds.push(clientPackage.id);

                        if (clientPackage.sourceClientPackageServiceIds && clientPackage.sourceClientPackageServiceIds.length > 0) {
                            usedPackageServiceIds.push(...clientPackage.sourceClientPackageServiceIds);
                        }
                        break;
                
                    case Model.SalesTypeEnum.PackageTransfer:
                        let clientPackageTransferSaleLineItem = (saleLine.item as ClientPackageTransferSaleLineItem);
                        if (clientPackageTransferSaleLineItem) {
                            newPackageIds.push(clientPackageTransferSaleLineItem.id);
                            if (clientPackageTransferSaleLineItem.donorClientPackageServiceId) {
                                usedPackageServiceIds.push(clientPackageTransferSaleLineItem.donorClientPackageServiceId);
                            }
                        }
                        break;

                    default:
                        if (saleLine.clientType === Model.ClientTypeEnum.Client && 
                            this.registerContext.isSaleLineAService(saleLine) && 
                            saleLine.redeemedPackages && 
                            saleLine.redeemedPackages.length > 0
                        ) {
                            saleLine.redeemedPackages.forEach((redeemedPackage) => {
                                redeemedPackage.packageServices.forEach((packageService) => {
                                    usedPackageServiceIds.push(packageService.id);
                                });
                            });
                        }
                        break;
                }
            }

            this.busyService.start();

            this.cleanupTask.then(() => {
                const businessDate = moment(sale.pastTransactionDateTime).startOf('day').toDate();

                const request = {
                    clientId: selectedSaleLine.clientId,
                    serviceId: selectedSaleLine.item.id,
                    quantity: selectedSaleLine.quantity,
                    redemptionType: selectedSaleLine.packageRedemptionType,
                    useExpiredPackages: selectedSaleLine.packageRedemptionPath.usesExpiredPackage,
                    unsoldPackageIds: newPackageIds,
                    usedPackageServiceIds: usedPackageServiceIds,
                    businessDate: businessDate,
                };

                return this.dataService
                    .customMethodData("api/ClientPackageRedemptionPath", "POST", request)
                    .then((response) => {
                        this.packageRedemptionPath = response.data;

                        // get the package services that will be remaining after this redemption is applied
                        let hashPackageServiceIds = [];
                        this.packageServicesRemaining = [];
                        
                        this.packageRedemptionPath.clientPackagesCreated.forEach((clientPackage) => {
                            clientPackage.packageServices.forEach((packageService) => {

                                if (!hashPackageServiceIds[packageService.id] &&
                                    !_.find(this.packageRedemptionPath.clientPackageServicesUsed, (usedPackageService) => {
                                        return usedPackageService.packageService.id == packageService.id;
                                    })) {

                                    this.packageServicesRemaining.push(packageService);
                                    hashPackageServiceIds[packageService.id] = packageService.id;
                                }
                            });
                        });
                    });
            })
            .finally(() => {
                this.busyService.stop();
            });
        }

        cleanupClientPackageRedemptionPath(): ng.IPromise<any> {
            if (this.packageRedemptionPath && this.packageRedemptionPath.clientId && this.packageRedemptionPath.serviceId && this.packageRedemptionPath.clientPackagesCreated && this.packageRedemptionPath.clientPackagesCreated.length > 0) {
                return this.dataService
                    .customMethodData(`api/ClientPackageRedemptionPath/${this.packageRedemptionPath.clientId}/Service/${this.packageRedemptionPath.serviceId}`, "DELETE", this.packageRedemptionPath)
                    .then(() => {
                        this.packageRedemptionPath = null;
                    });
            }
            else {
                this.packageRedemptionPath = null;
                var d = this.$q.defer();
                d.resolve();
                return d.promise;
            }
        }

        cancel() {
            this.busyService.start();
            this.cleanupClientPackageRedemptionPath()
                .then(() => {
                    this.registerContext.hideCheckoutButtons = false;
                    this.registerContext.selectSection(RegisterSectionTypeEnum.Services);
                })
                .finally(() => {
                    this.busyService.stop();
                });
        }

        apply() {
            this.selectedSaleLine.packageRedemptionPath = this.packageRedemptionPath;
            this.packageRedemptionPath = null;
            this.selectedSaleLine.item["productUsage"] = undefined;
            this.selectedSaleLine.packageRedeemed = true;
            this.busyService.start();
            this.registerContext.recalculateSale()
                .catch(() =>
                {
                    this.selectedSaleLine.packageRedeemed = false;
                })
                .finally(() => {
                    this.registerContext.selectSection(RegisterSectionTypeEnum.Services);
                    this.busyService.stop();
                });
        }

        getRedemptionTypeDisplayName(redemptionType: Model.PackageRedemptionTypeEnum) {
            var enumCfg = _.findWhere(this.packageRedemptionTypeNames, { id: redemptionType });
            if (enumCfg) {
                return enumCfg.displayName;
            }
            return "";
        }

        getPackageNumber(item: any) {
            return this.getPackageProperty(item, "clientPackageNumber");
        }

        getPackageStartDate(item: any) {
            return this.getPackageProperty(item, "startDate");
        }

        getPackageEndDate(item: any) {
            return this.getPackageProperty(item, "endDate");
        }

        getPackageProperty(item: any, propName: string) {
            if (this.packageRedemptionPath) {
                var packageItem = _.findWhere(this.packageRedemptionPath.clientPackagesUsed, { id: item.clientPackageId || item.packageService.clientPackageId });
                if (packageItem) {
                    return packageItem[propName];
                }
                packageItem = _.findWhere(this.packageRedemptionPath.clientPackagesCreated, { id: item.clientPackageId || item.packageService.clientPackageId });
                if (packageItem) {
                    return packageItem[propName];
                }
            }
            return "";
        }
    }

}